import { render, staticRenderFns } from "./TableFieldsContainer.vue?vue&type=template&id=231ad469&"
import script from "./TableFieldsContainer.vue?vue&type=script&lang=js&"
export * from "./TableFieldsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports